import { applyPwaDocumentBranding, pwaPngArtwork } from '@next/core-lib/pwa';
import { title_Agrifirm as de } from 'src/assets/i18n/de.json';
import { title_Agrifirm as en, title_Agravis } from 'src/assets/i18n/en.json';
import { title_Agrifirm as fr } from 'src/assets/i18n/fr.json';
import { title_Agrifirm as nlBE } from 'src/assets/i18n/nl-BE.json';
import { title_Agrifirm as nl } from 'src/assets/i18n/nl.json';

const appNames: Record<string, string> = { en, nl, 'nl-BE': nlBE, fr, de };

export function getPwaLocale(locale = 'en'): string {
  const normalized = locale.toLowerCase();
  return (
    Object.keys(appNames).find((key) => key.toLowerCase() === normalized) ??
    (Object.prototype.hasOwnProperty.call(appNames, normalized.split('-')[0])
      ? normalized.split('-')[0]
      : 'en')
  );
}

export function getPwaAppName(tenant?: string, locale?: string): string {
  return tenant === 'Agravis' ? title_Agravis : appNames[getPwaLocale(locale)];
}

export function getPwaFaviconUrl(tenant?: string): string {
  return `/assets/pwa/${tenant === 'Agravis' ? 'avidata' : 'agrifirm'}-favicon-96.png`;
}

export function applyPwaBranding(document: Document, tenant?: string, locale?: string): void {
  const brand = tenant === 'Agravis' ? 'avidata' : 'agrifirm';
  applyPwaDocumentBranding(document, {
    manifestUrl:
      tenant === 'Agravis'
        ? '/assets/manifest-agravis.webmanifest'
        : `/assets/manifest_${getPwaLocale(locale)}.json`,
    appName: getPwaAppName(tenant, locale),
    themeColor: tenant === 'Agravis' ? '#65b32e' : '#007f2d',
    ...pwaPngArtwork(`/assets/pwa/${brand}`),
    legacyTileImage: null,
  });
}
